import React from 'react'
import { useTranslation } from 'react-i18next'
import { Building2, UserCircle, Settings2, Users, Package } from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs'
import { BankAccountList } from '../components/settings/BankAccountList'
import { SenderProfileList } from '../components/settings/SenderProfileList'
import { PreferencesForm } from '../components/settings/PreferencesForm'
import { ClientList } from '../components/settings/ClientList'
import { ProductList } from '../components/settings/ProductList'

export default function Settings() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('settings.title')}</h1>
        <p className="text-muted-foreground">{t('settings.subtitle')}</p>
      </div>

      <Tabs defaultValue="bank-accounts" className="space-y-6">
        <TabsList className="grid w-full grid-cols-5 lg:w-auto lg:inline-flex">
          <TabsTrigger value="bank-accounts" className="gap-2">
            <Building2 className="h-4 w-4" />
            <span className="hidden sm:inline">{t('settings.tabs.bankAccounts')}</span>
          </TabsTrigger>
          <TabsTrigger value="sender-profiles" className="gap-2">
            <UserCircle className="h-4 w-4" />
            <span className="hidden sm:inline">{t('settings.tabs.senderProfiles')}</span>
          </TabsTrigger>
          <TabsTrigger value="clients" className="gap-2">
            <Users className="h-4 w-4" />
            <span className="hidden sm:inline">{t('settings.tabs.clients')}</span>
          </TabsTrigger>
          <TabsTrigger value="products" className="gap-2">
            <Package className="h-4 w-4" />
            <span className="hidden sm:inline">{t('settings.tabs.products')}</span>
          </TabsTrigger>
          <TabsTrigger value="preferences" className="gap-2">
            <Settings2 className="h-4 w-4" />
            <span className="hidden sm:inline">{t('settings.tabs.preferences')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="bank-accounts">
          <BankAccountList />
        </TabsContent>

        <TabsContent value="sender-profiles">
          <SenderProfileList />
        </TabsContent>

        <TabsContent value="clients">
          <ClientList />
        </TabsContent>

        <TabsContent value="products">
          <ProductList />
        </TabsContent>

        <TabsContent value="preferences">
          <PreferencesForm />
        </TabsContent>
      </Tabs>
    </div>
  )
}
